var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "idleFade" } }, [
        _vm.showConfirmation
          ? _c("div", { staticClass: "idle-confirmation-overlay" }, [
              _c("div", { staticClass: "idle-confirmation-modal" }, [
                _c(
                  "div",
                  { staticClass: "modal-icon" },
                  [
                    _c("b-icon", {
                      attrs: {
                        icon: "clock-history",
                        "font-scale": "3",
                        variant: "warning",
                      },
                    }),
                  ],
                  1
                ),
                _c("h2", { staticClass: "modal-title" }, [
                  _vm._v(" Você ainda está aí? "),
                ]),
                _c("p", { staticClass: "modal-message" }, [
                  _vm._v(" A sessão será finalizada em "),
                  _c("strong", [_vm._v(_vm._s(_vm.countdown))]),
                  _vm._v(" segundos "),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "btn-continue",
                    on: { click: _vm.onContinueSession },
                  },
                  [_vm._v(" Continuar comprando ")]
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _c(
        "transition",
        { attrs: { name: "idleFade" } },
        [_vm.showRestScreen ? _c("atm-rest-screen") : _vm._e()],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }